module.exports = __webpack_public_path__ + "static/media/kw.e15c1412.svg";